<template>
  <v-select
    v-if="languages.length > 1"
    v-model="previewLanguage"
    :items="languages"
    variant="plain"
    itemTitle="text"
    placeholder="Lang"
    class="text-white [&_.v-field\_\_append-inner]:py-0! [&_.v-field\_\_input]:py-0! [&_.v-icon.v-icon]:self-center! [&_.v-icon.v-icon]:text-white! [&_.v-select\_\_selection-text]:mb-0!"
    persistentPlaceholder
  />
</template>

<script>
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import { usePromptStore } from "@/pinia/promptStore";

export default {
  name: "RfLanguagePreview",
  mixins: [LanguagePreviewMixin],
  props: ["model", "actions"],
  setup: () => ({ promptStore: usePromptStore() }),
  data() {
    return {
      previewLanguage: null,
    };
  },
  computed: {
    languages() {
      if (!this.isLocalized) return [];
      const translations = this.model.parsed_translations;
      if (!translations) return [];
      const items = [];
      Object.keys(translations).forEach(language => {
        const values = translations[language];
        if (values.default) {
          items.unshift({ text: `${language} (default)`, value: language });
        } else {
          items.push({ text: language, value: language });
        }
      });
      return items;
    },
  },
  watch: {
    "previewLanguage": function (to) {
      if (to) {
        this.promptStore.currLanguage = to.value || to;
      }
    },
    "promptStore.prompt": function (to) {
      if (to.parsed_translations && !this.previewLanguage && this.languages.length) {
        this.previewLanguage = this.languages[0].value;
      }
    },
    "isLocalized": function (to) {
      if (to && !this.previewLanguage && this.languages.length)
        this.previewLanguage = this.languages[0].value;
    },
  },
  mounted() {
    if (this.languages.length) {
      this.previewLanguage = this.promptStore.currLanguage || this.languages[0].value;
    }
  },
};
</script>
